<template>
    <div class="content-box">
        <Title />
        
        <div class="nav-wrapper">
            <el-menu
                :default-active="activeNav"
                class="el-menu-demo nav-menu"
                mode="horizontal"
                @select="handleNavSelect"
            >
                <el-menu-item index="报告发布">
                    报告发布
                </el-menu-item>
                <el-menu-item index="报告 车">
                    汽车报告
                </el-menu-item>
                <el-menu-item index="报告 新能源">
                    新能源报告
                </el-menu-item>
                <el-menu-item index="报告 二手车">
                    二手车报告
                </el-menu-item>
            </el-menu>
        </div>

        <Report />
    </div>
</template>

<script>
import { Report } from 'shared'

export default {
    name: 'report',
    components: {
        Report
    },
    data() {
        return {
            activeNav: '报告发布',
            params: {
                json: 0
            }
        }
    },
    created() {
        this.$store.commit('textparams', this.params)
        this.$store.commit('changeKeys', this.activeNav)
        this.$store.dispatch('getText')
    },
    methods: {
        handleNavSelect(key) {
            this.activeNav = key
            this.$store.commit('changeKeys', key)
            this.$store.dispatch('getText')
        }
    }
}
</script>

<style scoped>
.nav-wrapper {
    background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
    border-bottom: 2px solid #02973a;
    margin-bottom: 20px;
}
.nav-menu {
    display: flex;
    padding: 0;
    margin: 0;
    border: none;
}
.nav-menu .el-menu-item {
    padding: 14px 40px;
    margin: 0;
    border-bottom: none;
    font-weight: 600;
    font-size: 15px;
    color: #333;
    transition: all 0.3s ease;
}
.nav-menu .el-menu-item:hover,
.nav-menu .el-menu-item.is-active {
    color: #02973a;
    background-color: rgba(2, 151, 58, 0.1);
}
@media (max-width: 768px) {
    .nav-menu .el-menu-item {
        padding: 12px 24px;
        font-size: 14px;
    }
}
@media (max-width: 480px) {
    .nav-menu .el-menu-item {
        padding: 10px 16px;
        font-size: 13px;
    }
}
</style>